import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import {withTranslation} from 'react-i18next';
import styled, {css} from 'styled-components';

import {getPageDataSelector} from '../../selectors/page';
import {setPageOrderBy} from '../../actions/PageActions';

import Link from '../styleguide/Link';
import {capfl} from '../../utils/index';
import {getThemeConfigSelector} from '../../selectors/index';

const StyledSort = styled.section`
  display: flex;
  margin-bottom: 10px;
`;

const StyledLink = styled(Link)`
  && {
    text-decoration: none;
    display: block;
    margin-right: 10px;
    font-weight: 600;
    font-size: 0.9em;
    color: #aaa;
    ${({ isActive }) =>
      isActive &&
      css`
        color: ${({ theme }) => _.get(theme, 'colors.secondary', null)};
      `};
    &:last-child {
      margin-right: 0;
    }
  }
`;

class Sort extends PureComponent {
  onChangeSortClick = value => e => {
    e.preventDefault();
    const { changePageOrder } = this.props;
    changePageOrder(value);
  };
  render() {
    const { t, orderBy, config } = this.props;
    return (
      <StyledSort>
        {_.map(_.get(config, 'sort', []), option => {
          const { label, value } = option;
          const isActive = orderBy === value;
          return (
            <StyledLink
              key={'sort-option-' + value}
              href="#"
              isActive={isActive}
              onClick={this.onChangeSortClick(value)}
            >
              {capfl(t(label))}
            </StyledLink>
          );
        })}
      </StyledSort>
    );
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const getThemeConfig = getThemeConfigSelector();
  return (state, props) => {
    return {
      orderBy: _.get(getPageData(state, props), 'orderBy'),
      config: getThemeConfig(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    changePageOrder: orderBy => {
      const { history } = props;
      dispatch(setPageOrderBy(orderBy, history));
    }
  };
};

const SortConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(Sort);

export default withTranslation()(withRouter(SortConnected));
